import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "intro-block" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "intro-title genre-tag" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rp", null, "/*", -1)
const _hoisted_8 = { class: "genre-trans" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("rp", null, "*/", -1)
const _hoisted_11 = { class: "style-list" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StyleTag = _resolveComponent("StyleTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.info.primary_img,
          class: "img-fluid"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", _hoisted_6, [
          _createElementVNode("ruby", null, [
            _createTextVNode(_toDisplayString(_ctx.info.name) + " ", 1),
            _hoisted_7,
            _createElementVNode("rt", null, [
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.info.name_orig) + " ", 1),
                (_ctx.info.name_alt)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " / " + _toDisplayString(_ctx.info.name_alt), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showChilds, (style) => {
            return (_openBlock(), _createBlock(_component_StyleTag, {
              key: style._id,
              genre: style,
              full: 1,
              class: "tag-list"
            }, null, 8, ["genre"]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "genre-intro-box mt-3",
          innerHTML: _ctx.markdown.render(_ctx.info.profile)
        }, null, 8, _hoisted_12)
      ])
    ])
  ]))
}